// extracted by mini-css-extract-plugin
module.exports = {"heading":"ComponentHeading_heading__73znu"};